export const httpStatusOf = (error: unknown): number | undefined => {
  const status = (error as { httpStatus?: unknown } | null)?.httpStatus;
  return typeof status === "number" ? status : undefined;
};
